import React, { useState } from "react"
import { gql, useMutation, useQuery } from "@apollo/client"
import ErrorScreen from "../ErrorScreen"
import { Divider, Input, Select, Spin } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { uiHandleError } from "../../utils"
import { CATEGORY } from "../../enums/ItemTypes"
import getSlug from "speakingurl"

const ALL_CATEGORY_LIST_QUERY = gql`
  {
    categories(order_by: { name: asc }) {
      id
      parent_id
      name
      description
    }
  }
`

const CREATE_CATEGORY_MUTATION = gql`
  mutation insertCategory($data: categories_insert_input!) {
    insert_categories_one(object: $data) {
      id
    }
  }
`

const INSERT_CATEGORY_MUTATION = gql`
  mutation insertSeo($data: seo_insert_input!) {
    insert_seo(objects: [$data]) {
      affected_rows
    }
  }
`

const CategorySelector = ({ value, onChange, multiple = false }) => {
  const { loading, error, data, refetch } = useQuery(ALL_CATEGORY_LIST_QUERY)
  const [insertCategory] = useMutation(INSERT_CATEGORY_MUTATION)
  const [newCategoryName, setNewCategoryName] = useState("")
  const [creatingNewCategory, setCreatingNewCategory] = useState(false)

  if (loading) {
    return <Spin spinning />
  }

  if (error) {
    return <ErrorScreen error={error} />
  }

  const { categories } = data

  const onCategoryChange = newValue => {
    onChange(newValue)
  }

  const createCategory = async () => {
    setCreatingNewCategory(true)
    try {
      const data = {
        slug: getSlug(newCategoryName),
        title: newCategoryName,
        description: newCategoryName,
        item_type: CATEGORY,
        category: {
          data: {
            name: newCategoryName,
          },
        },
      }

      await insertCategory({ variables: { data } })
      await refetch()
      setNewCategoryName("")
    } catch (error) {
      uiHandleError({ error })
    }

    setCreatingNewCategory(false)
  }

  const defaultValue = multiple ? [] : null

  return (
    <>
      <Select
        defaultValue={value || defaultValue}
        style={{
          width: "100%",
        }}
        mode={multiple ? "multiple" : null}
        showSearch
        optionFilterProp="children"
        onChange={onCategoryChange}
        dropdownRender={menu => (
          <Spin spinning={creatingNewCategory}>
            {menu}
            <Divider style={{ margin: "4px 0" }} />
            <div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
              <Input
                style={{ flex: "auto" }}
                value={newCategoryName}
                onChange={e => setNewCategoryName(e.target.value)}
              />
              <a
                style={{
                  flex: "none",
                  padding: "8px",
                  display: "block",
                  cursor: "pointer",
                }}
                onClick={createCategory}
              >
                <PlusOutlined /> crea nuova
              </a>
            </div>
          </Spin>
        )}
      >
        {!multiple && (
          <Select.Option value={null} key={"null"}>
            nessuna
          </Select.Option>
        )}
        {categories.map(({ id, name }) => (
          <Select.Option value={id} key={id}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </>
  )
}

export default CategorySelector
